import axios from "@/axios";
export const namespaced = true;

const defaultData = {
  orderId: null,
  usName: null,
  usOfficeId: null,
  usAddress: null,
  partnerName: null,
  partnerOfficeId: null,
  partnerAddress: null,
};

export const state = {
  financeOfficeInformation: Object.assign({}, defaultData),
  status: false,
  partnerNationCountryId: 0,
  allFinanceOffices: [],
  paginatedFinanceOffices: [],
  financeOfficeInformationErrors: [],

};

export const getters = {
  financeOfficeInformation: (state) => {
    return state.financeOfficeInformation;
  },

  financeOfficeInformationStatus: (state) => {
    return state.status;
  },
  partnerNationCountryId: (state) => {
    return state.partnerNationCountryId;
  },
  allFinanceOffices: (state) => state.allFinanceOffices,
  paginatedFinanceOffices: (state) => state.paginatedFinanceOffices,
  financeOfficeInformationErrors: (state) => state.financeOfficeInformationErrors
};

export const mutations = {
  SET_FINANCE_OFFICE_INFORMATION(state, response) {
    state.financeOfficeInformation = Object.assign({}, defaultData, response.data)
  },
  SET_ALL_FINANCE_OFFICES(state, response) {
    state.allFinanceOffices = response.data;
  },
  SET_PAGINATED_FINANCE_OFFICES(state, response) {
    state.paginatedFinanceOffices = response.data;
  },
  SET_STATUS(state, value) {
    state.status = value;
  },
  SET_PN_COUNTRY(state, value) {
    state.partnerNationCountryId = value;
  },
  CLEAR_DATA(state) {
    state.financeOfficeInformation = Object.assign({}, defaultData)
  },
  CLEAR_PARTNER_FIELDS(state) {
    state.financeOfficeInformation.partnerName = defaultData.partnerName;
    state.financeOfficeInformation.partnerOfficeId = defaultData.partnerOfficeId;
    state.financeOfficeInformation.partnerAddress = defaultData.partnerAddress;
  },
  SET_ERRORS(state, data) {
    state.financeOfficeInformationErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.financeOfficeInformationErrors = [];
  }
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },
  async getFinanceOfficeInformationStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_STATUS", false)
    } else {
      return await axios.get('/api/orderfinanceoffices/order/status/' + id)
        .then(({ data }) => {
          if(data && data.length === 0) {
            commit("SET_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
          commit("SET_STATUS", false);
            commit("SET_ERRORS", data);
        }
        })
    }
  },
  async getPartnerNationCountryId({ commit }, id) {
    if (id == 0) {
      commit("SET_PN_COUNTRY", 0)
    } else {
      return await axios.get('/api/orderfinanceoffices/order/pncountry/' + id)
        .then(({ data }) => {
          commit("SET_PN_COUNTRY", data);
        })
    }
  },
  async getFinanceOfficeInformation({ commit, dispatch }, id) {
    commit("SET_FINANCE_OFFICE_INFORMATION", await axios.get(`/api/orderfinanceoffices/order/${id}`));
  },
  async saveFinanceOfficeInformation({ commit, state }, orderId) {
    state.financeOfficeInformation.orderId = orderId;
    return await axios.post("/api/orderfinanceoffices/", state.financeOfficeInformation)
  },
  async getPaginatedFinanceOffices({ commit, state }, apiInfo) {
    commit("SET_PAGINATED_FINANCE_OFFICES", await axios.post(`api/financialoffices/search/paginated`, 
                                                              apiInfo,
                                                              { config: { showToast: false } }));
  },
  async getAllFinanceOffices({ commit }, apiInfo) {
    commit("SET_ALL_FINANCE_OFFICES",  await axios.post(`api/financialoffices/search`, apiInfo))
  },

  clearPartnerFields({ commit }) {
    commit("CLEAR_PARTNER_FIELDS");
  },
};
